import React, { ReactElement, Dispatch, SetStateAction } from 'react';

import Modal from '~/components/Modal';
import Link from '~/components/flow/Link';
import Button from '~/components/buttons/Button';
import { stopEventEffects } from '~/utils';
import VARIANTS from '~/constants/variants';

interface PromoModalProps {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  title: string;
  promoText?: string;
  promoLink?: string;
  buttonLabel: string;
}

function PromoModal({
  visible,
  setVisible,
  title,
  promoText,
  promoLink,
  buttonLabel,
}: PromoModalProps): ReactElement {
  const hider = (event) => {
    stopEventEffects(event);
    setVisible(false);
  };

  // Styling
  const modalContainerStyle = {
    padding: '0em 0.5em',
  };

  return (
    <Modal visible={visible} title={title} hider={hider}>
      <div style={modalContainerStyle}>
        {promoLink ? (
          <Link href={promoLink}>
            <span>{promoText || promoLink}</span>
          </Link>
        ) : (
          <span>{promoText}</span>
        )}
      </div>
      <br />
      <Button
        label={buttonLabel}
        width="100%"
        variant={VARIANTS.success}
        callback={hider}
      />
    </Modal>
  );
}

export default PromoModal;
